import { useEffect, useState } from 'react';

import { Image, Platform } from 'react-native';

export default function useImageRatio(imageUrl?: string) {
    const [ratio, setRatio] = useState(0);
    const [imageRatioError, setImageRatioError] = useState(null);

    useEffect(() => {
        imageUrl &&
            Image.getSize(
                imageUrl,
                (width: number, height: number) => {
                    if (!Number.isNaN(width / height)) {
                        setRatio(width / height);
                    }
                },
                (error) => {
                    setImageRatioError(
                        Platform.select({
                            web: {
                                status: 500,
                                message: 'Internal Server Error',
                                url: imageUrl,
                            },
                            default: error,
                        }),
                    );
                },
            );
    }, [imageUrl]);

    return { ratio, imageRatioError };
}
